import Vue from 'vue';

export default {
  APPEND_DATA_SOURCES_GROUPS: (state, payload) => {
    if (state.dataSourcesGroups[payload.mapId]) {
      state.dataSourcesGroups[payload.mapId] = state.dataSourcesGroups[payload.mapId].concat(payload.val);
    } else {
      Vue.set(state.dataSourcesGroups, payload.mapId, payload.val);
    }
  },

  REMOVE_DATA_SOURCES_GROUP: (state, payload) => {
    let groups = state.dataSourcesGroups[payload.mapId];
    if (Array.isArray(groups)) {
      state.dataSourcesGroups[payload.mapId] = state.dataSourcesGroups[payload.mapId].filter(item => {
        return item.title != payload.title;
      })
    }
  },

  REFRESH_DATA_SOURCES: (state, payload) => {
    // Force refresh by triggering a reactive update
    if (state.dataSourcesGroups[payload.mapId]) {
      const groups = state.dataSourcesGroups[payload.mapId];
      const targetGroup = groups.find(group => group.title === payload.groupTitle);
      if (targetGroup && targetGroup.dataSources) {
        // Trigger reactivity by updating the data sources
        targetGroup.dataSources.forEach(dataSource => {
          if (dataSource.get && dataSource.get.url) {
            // Force a refresh by updating the URL temporarily
            const originalUrl = dataSource.get.url;
            dataSource.get.url = originalUrl + '?refresh=' + Date.now();
            setTimeout(() => {
              dataSource.get.url = originalUrl;
            }, 100);
          }
        });
      }
    }
  },
};


// WEBPACK FOOTER //
// ./src/store/maps/mutations.js